// MENU_ORDEM_2810 (GROK2): nova ordem do menu lateral pedida pelo Gustavo (28/10).
// Só reorganiza/esconde no menu: rotas, páginas e backend continuam iguais.
// Desligar: criar /opt/painel_mn/private/MENU_ORDEM_2810_OFF (volta o menu antigo).
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Zap, X } from 'lucide-react';
import DashboardQuickTestGrid from '../components/DashboardQuickTestGrid';
import './menuOrdem2810.css';
import { agrupaTabs2810 } from './agrupa2810Logic'; // AGRUPA_2810
import { useAuraxFlags } from './auraxFlags';
import { hidePath2810 } from './semApps2810'; // SEM_ATIVAR_APPS_2810 / SEM_CARTEIRA_2810

export { reorderMenu2810, MENU_HIDDEN_2810 } from './menuOrdem2810Logic';

// MENU_ENXUTO_2810: abas internas das páginas fundidas
const ENXUTO_TABS_2810 = [
  [['/financeiro', 'Financeiro'], ['/logs-financeiros', 'Movimentações'], ['/gestor-xui/credit-logs', 'Extrato de créditos']],
  [['/settings', 'Ajustes'], ['/gestor-xui/servers', 'Servidores'], ['/gestor-xui/credential-generation', 'Credenciais']],
  [['/gestor-xui/gateway', 'Integrações com bancos'], ['/api-integrations', 'API e automações']],
  [['/team', 'Equipe'], ['/permissions', 'Permissões']],
  [['/gestor-xui/partner-apps', 'Catálogo de aplicativos'], ['/gestor-xui/categories', 'Planos']],
];

const chip = 'inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-semibold hover:bg-muted';
const on = 'bg-primary text-primary-foreground border-primary hover:bg-primary';

function Tabs({ pathname, tabs }) {
  return <div className="mb-3 flex flex-wrap gap-2" data-testid="menu-ordem-2810-tabs">
    {tabs.map(([to, label]) => <Link key={to} to={to} className={`${chip} ${pathname === to ? on : ''}`}>{label}</Link>)}
  </div>;
}

export function QuickTestButton({ inline, className }) {
  const [open, setOpen] = useState(false);
  const btn = <button type="button" className={className || `${chip} ${on}`} onClick={() => setOpen(true)} data-testid="teste-rapido-2810"><Zap size={14} />Teste rápido</button>;
  return <>
    {inline ? btn : <div className="mb-3 flex justify-end">{btn}</div>}
    {open ? <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/60 p-4 pt-16" onClick={() => setOpen(false)}>
      <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
        <button type="button" aria-label="Fechar" className="absolute right-2 top-2 z-10 rounded-full bg-background p-1" onClick={() => setOpen(false)}><X size={18} /></button>
        <DashboardQuickTestGrid className="bg-background" />
      </div>
    </div> : null}
  </>;
}

const CLIENT_TABS = [['/gestor-xui/clients', 'Todos (ativos / vencidos no filtro)'], ['/gestor-xui/live-clients', 'Conectados agora'], ['/gestor-xui/inactive-clients', 'Inativos']];
const RESELLER_TABS = [['/gestor-xui/resellers', 'Revendas'], ['/gestor-xui/inactive-resellers', 'Revendas inativas']];

// PERMISSOES_REVENDA_2810: Permissões sai de Equipe e vira aba de Revendas (rota igual)
const RESELLER_TABS_PERM_2810 = [['/gestor-xui/resellers', 'Revendas'], ['/permissions', 'Permissões dos perfis']];
const WALLET_TABS_2810 = [['/buy-credits', 'Comprar créditos'], ['/gestor-xui/credit-logs', 'Extrato de créditos'], ['/gestor-xui/my-portfolio', 'A minha carteira']];
// AGRUPA_2810: abas internas do grupo (só o que o usuário já podia abrir)
function AgrupaTabs2810({ g, quickTest, pill }) {
  if (pill) return <AgrupaPills2810 g={g} />; // TESTES_LAYOUT_2810
  const sub = 'inline-flex items-center rounded-full px-2 py-0.5 text-xs hover:bg-muted';
  return <div className="mb-3" data-testid={`agrupa-2810-${g.key}`}>
    <div className="flex flex-wrap items-center gap-2">
      {g.tabs.map((t) => <Link key={t.label} to={t.to} className={`${chip} ${t.active ? on : ''}`}>{t.label}</Link>)}
      <span className="ml-auto flex gap-2">
        {g.quick.map((q) => <Link key={q.to} to={q.to} className={`${chip} ${on}`}>{q.label}</Link>)}
        {quickTest}
      </span>
    </div>
    {g.sub.length ? <div className="mt-2 flex flex-wrap gap-1">{g.sub.map((s) => <Link key={s.to} to={s.to} className={`${sub} ${s.active ? 'font-semibold underline' : 'text-muted-foreground'}`}>{s.label}</Link>)}</div> : null}
  </div>;
}

// TESTES_LAYOUT_2810: sub-abas em pílulas (segmentado), rolagem lateral no celular
function AgrupaPills2810({ g }) {
  return <div className="mo-pills-2810" data-testid={`agrupa-2810-${g.key}`}>
    <div className="mo-pills-2810-row">{g.tabs.map((t) => <Link key={t.label} to={t.to} className={`mo-pill-2810 ${t.active ? 'is-on' : ''}`}>{t.label}</Link>)}</div>
    {g.sub.length ? <div className="mo-pills-2810-sub">{g.sub.map((s) => <Link key={s.to} to={s.to} className={`mo-pill-2810-s ${s.active ? 'is-on' : ''}`}>{s.label}</Link>)}</div> : null}
  </div>;
}

export function MenuOrdemExtras2810({ pathname, isAdmin, enxuto, permRevenda, allowedPaths, agrupa, navPaths }) {
  const p = String(pathname || '').replace(/\/+$/, '');
  const f2810 = useAuraxFlags();
  if (agrupa) {
    const g0 = agrupaTabs2810(p, agrupa, { navPaths, isAdmin });
    const g = g0 && { ...g0, tabs: g0.tabs.filter((t) => !hidePath2810(t.to, f2810)), sub: g0.sub.filter((s) => !hidePath2810(s.to, f2810)), quick: g0.quick.filter((q) => !hidePath2810(q.to, f2810)) };
    if (g && g.sub.length < 2) g.sub = []; // SEM_CARTEIRA_2810: some Todos/Minha carteira
    const pill = !!f2810?.testes_layout_2810;
    // FIN_REVENDA_2910: revenda em página de grupo não cai nas abas antigas (Financeiro|Movimentações)
    if (g && f2810?.fin_revenda_2910) {
      if (!g.tabs.length && g.sub.length) { g.tabs = g.sub; g.sub = []; }
      return g.tabs.length || g.quick.length ? <AgrupaTabs2810 g={g} pill={pill} /> : null;
    }
    if (g && (g.tabs.length || g.quick.length)) return <AgrupaTabs2810 g={g} pill={pill} quickTest={p === '/gestor-xui/tests' && !pill ? <QuickTestButton inline /> : null} />;
  }
  // AUDITORIA_REVENDA_2810: abas só para páginas que o usuário pode abrir (allowedPaths só vem com o switch ligado)
  if (allowedPaths) {
    const ok = (tabs) => { const t = (tabs || []).filter(([to]) => to === p || allowedPaths.has(to)); return t.length > 1 ? t : null; };
    if (permRevenda && isAdmin && RESELLER_TABS_PERM_2810.some(([to]) => to === p)) return <Tabs pathname={p} tabs={RESELLER_TABS_PERM_2810} />;
    if (enxuto) {
      const set0 = ENXUTO_TABS_2810.find((tabs) => tabs.some(([to]) => to === p));
      const t = set0 && ok(set0.filter(([to]) => isAdmin ? !(permRevenda && to === '/permissions') : !['/gestor-xui/servers', '/gestor-xui/credential-generation', '/permissions'].includes(to)));
      if (t) return <Tabs pathname={p} tabs={t} />;
    }
    if (CLIENT_TABS.some(([to]) => to === p)) { const t = ok(isAdmin ? CLIENT_TABS : CLIENT_TABS.slice(0, 2)); return t ? <Tabs pathname={p} tabs={t} /> : null; }
    if (isAdmin && RESELLER_TABS.some(([to]) => to === p)) return <Tabs pathname={p} tabs={RESELLER_TABS} />;
    if (!isAdmin && WALLET_TABS_2810.some(([to]) => to === p)) { const t = ok(WALLET_TABS_2810.filter(([to]) => !hidePath2810(to, f2810))); return t ? <Tabs pathname={p} tabs={t} /> : null; }
    return null;
  }
  if (permRevenda && isAdmin && RESELLER_TABS_PERM_2810.some(([to]) => to === p)) return <Tabs pathname={p} tabs={RESELLER_TABS_PERM_2810} />;
  if (enxuto) {
    const set0 = ENXUTO_TABS_2810.find((tabs) => tabs.some(([to]) => to === p));
    const set = set0 && permRevenda ? (set0.filter(([to]) => to !== '/permissions').length > 1 ? set0.filter(([to]) => to !== '/permissions') : null) : set0;
    if (set) return <Tabs pathname={p} tabs={isAdmin ? set : set.filter(([to]) => !['/gestor-xui/servers', '/gestor-xui/credential-generation', '/permissions'].includes(to))} />;
  }
  if (CLIENT_TABS.some(([to]) => to === p)) return <Tabs pathname={p} tabs={isAdmin ? CLIENT_TABS : CLIENT_TABS.slice(0, 2)} />;
  if (isAdmin && RESELLER_TABS.some(([to]) => to === p)) return <Tabs pathname={p} tabs={RESELLER_TABS} />;
  if (p === '/gestor-xui/tests' && !f2810?.testes_layout_2810) return <QuickTestButton />;
  return null;
}
